<ejs-toolbar
    #moduleToolbar
    id="moduleToolbar"
    overflowMode="Scrollable"
    scrollStep="300"
>
    <e-items>
        <e-item
            [align]="'center'"
            tooltipText="vytvořit hot-line"
            type="button"
        >
            <ng-template #template>
                <button
                    (click)="navigateToTab('addHotline')"
                    cssClass="e-btn e-primary btn-p-zero e-small"
                    ejs-button
                    title="vytvořit hot-line"
                    type="button"
                >
                    <i class="fa-light fa-lg fa-plus mr-2"></i>
                    vytvořit hot-line
                </button>
            </ng-template>
        </e-item>
        <e-item type="Separator"></e-item>
        <e-item
            [align]="'center'"
            tooltipText="vytvořit zápis hot-line"
            type="button"
        >
            <ng-template #template>
                <button
                    (click)="navigateToTab('addHotlineReport')"
                    cssClass="e-btn e-primary btn-p-zero e-small"
                    ejs-button
                    title="vytvořit zápis hot-line"
                    type="button"
                >
                    <i class="fa-light fa-lg fa-sticky-note mr-2"></i>
                    vytvořit zápis hot-line
                </button>
            </ng-template>
        </e-item>
        <e-item type="Separator"></e-item>
        <e-item [align]="'center'" tooltipText="seznam hot-line" type="button">
            <ng-template #template>
                <button
                    (click)="navigateToTab()"
                    cssClass="e-btn e-warning btn-p-zero e-small"
                    ejs-button
                    title="seznam hot-line"
                    type="button"
                >
                    <i class="fa-light fa-lg fa-list mr-2"></i>
                    seznam hot-line
                </button>
            </ng-template>
        </e-item>
    </e-items>
</ejs-toolbar>
<app-hotline-calendar></app-hotline-calendar>
